import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type DepartmentDropdownQueryVariables = {};


export type DepartmentDropdownQuery = (
  { __typename?: 'Query' }
  & Pick<Types.Query, 'allMaintenanceAreas'>
);

export const DepartmentDropdownDocument = gql`
    query DepartmentDropdown {
  allMaintenanceAreas
}
    `;

    export function useDepartmentDropdownQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DepartmentDropdownQuery, DepartmentDropdownQueryVariables>) {
      return ApolloReactHooks.useQuery<DepartmentDropdownQuery, DepartmentDropdownQueryVariables>(DepartmentDropdownDocument, baseOptions);
    };
      export function useDepartmentDropdownLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentDropdownQuery, DepartmentDropdownQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<DepartmentDropdownQuery, DepartmentDropdownQueryVariables>(DepartmentDropdownDocument, baseOptions);
      };
      
export type DepartmentDropdownQueryHookResult = ReturnType<typeof useDepartmentDropdownQuery>;
export type DepartmentDropdownQueryResult = ApolloReactCommon.QueryResult<DepartmentDropdownQuery, DepartmentDropdownQueryVariables>;